import WidgetBase from "../widget.base";
import { each } from 'App/lib/util';

export default class ProductGrid extends WidgetBase {
    static selector = '[data-js-product-grid]';
    btnSelector = '[data-js-button-play]';

    constructor(el) {
        super(el);
        this._button = this.el.querySelector('[data-js-product-grid-button]');
        this._container = this.el.querySelector('.usc-product-grid__container');
        this._numberOfItems = this.el.dataset.jsProductGridNumberItems;

        this.listenLoadMoreButton();
        this.attachVideoControls();
    }


    listenLoadMoreButton() {
        if (this._button) {
            this._button.addEventListener(
                'click',
                () => {
                    let cards = this._container.querySelectorAll('.usc-product-grid__card');
                    let visible = this._numberOfItems;
                    //Show less
                    if (Array.from(cards).some(c => c.classList.contains("usc-product-grid__card--hidden")) == false) {
                        each(cards, (card, index) => {
                            if ((index + 1) > visible) {
                                card.classList.add('usc-product-grid__card--hidden');
                            }
                        });
                    }
                    //Show more
                    else {
                        each(cards, (card) => {
                            if (card.classList.contains('usc-product-grid__card--hidden') && visible > 0) {
                                card.classList.remove('usc-product-grid__card--hidden');
                                visible = visible - 1;
                            }
                        });
                    }

                    //Change text for button on show less
                    if (Array.from(cards).some(c => c.classList.contains("usc-product-grid__card--hidden")) == false) {
                        this._button.innerHTML = this._button.dataset.jsShowLess;
                    }
                    else {
                        this._button.innerHTML = this._button.dataset.jsShowMore;
                    }
                }
            );
        }
    }

    attachVideoControls(){
        let cards = this._container.querySelectorAll('.usc-product-grid__card');

        each(cards, (card) => {
            let button = card.querySelector(this.btnSelector);
            if (button) {
                let playerContainer = card.querySelector('.usc-product-grid__card-video-player');
                let video = playerContainer.querySelector('video');
                button.addEventListener(
                    'click',
                    () => {
                        if (playerContainer.classList.contains('usc-product-grid__card-video-player--hidden')) {
                            playerContainer.classList.remove('usc-product-grid__card-video-player--hidden');
                        }
                        if (!!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)) {
                            button.classList.add('usc-product-grid__card__play-toggle--will-play');
                            button.classList.remove('usc-product-grid__card__play-toggle--will-pause')
                            video.pause();
                        }
                        else {
                            button.classList.remove('usc-product-grid__card__play-toggle--will-play');
                            button.classList.add('usc-product-grid__card__play-toggle--will-pause')
                            video.play();
                        }

                    }
                );
            }
        });
    }

}
